import React from 'react';
import { PayloadStates } from '@lore/utils';
import _ from 'lodash';
import ChartLoader from '../../states/_charts/ChartLoader';
import DonutChart from '../../states/_charts/DonutChart';
import colors from 'tailwindcss/colors';
import useActiveEducators from './_hooks/useActiveEducators';
import useInactiveEducators from './_hooks/useInactiveEducators';
import useSleepingEducators from './_hooks/useSleepingEducators';
import useIncompleteEducators from './_hooks/useIncompleteEducators';

export default function EducatorStatusYear(props) {
  const { state, network, schoolStart, schoolEnd, subtitle, currentTimestamp } = props;

  const requests = [
    {
      label: 'Active',
      partners: useActiveEducators(state, network, schoolStart, schoolEnd, currentTimestamp)
    },
    {
      label: 'Sleeping',
      partners: useSleepingEducators(state, network, schoolStart, schoolEnd, currentTimestamp)
    },
    {
      label: 'Inactive',
      partners: useInactiveEducators(state, network, schoolStart, schoolEnd, currentTimestamp)
    },
    {
      label: 'Incomplete',
      partners: useIncompleteEducators(state, network, schoolStart, schoolEnd, currentTimestamp)
    }
  ];

  const loading = _.reduce(requests, function(result, request) {
    return result || request.partners.state === PayloadStates.FETCHING;
  }, false);

  if (loading) {
    return (
      <ChartLoader
        title="Educator Status"
        subtitle={subtitle || 'For school year'}
      />
    );
  }

  const series = requests.map(r => r.partners.meta.totalCount);
  const labels = requests.map(r => r.label);

  return (
    <DonutChart
      title="Educator Status"
      subtitle={subtitle || 'For school year'}
      labels={labels}
      series={series}
      colors={[
        colors.emerald['400'],
        colors.blue['400'],
        colors.red['400'],
        colors.yellow['400']
      ]}
    />
  );
}
